export const STATUS_BUSY = 'STATUS_BUSY'
export const STATUS_ERROR = 'STATUS_ERROR'
export const STATUS_STEP = 'STATUS_STEP'

export function busy(payload) {
	return {
		type: STATUS_BUSY,
		payload
	}
}

export function error(payload) {
	return {
		type: STATUS_ERROR,
		payload
	}
}

export function step(payload) {
	return {
		type: STATUS_STEP,
		payload
	}
}
